import { Skeleton } from '@view/view_booking/components/skeleton';
import { BookingScreen, useBooking } from '@view/view_booking/hooks/use_booking';
import { useEffect } from 'react';

export const ViewBookingSetup = () => {
	const viewBooking = useBooking();

	useEffect(() => {
		try {
			viewBooking.setupNewBasket();
		} catch {
			viewBooking.goToScreen(BookingScreen.Error);
		}
	}, [viewBooking.setupNewBasket, viewBooking.goToScreen]);

	return <Skeleton />;
};
